import { constants, DISCOUNT_TYPES } from "../constant/constants";
import ApiService from "../utils/ApiService";
import { getParsedNumber, roundNumber } from "../utils/Common";
import * as qz from "qz-tray";
import { getPaymentCommonInfo } from "./order-common-service";

export const getIsRoundingApplicable = (paymentMethods, roundedValues) => {
  const filteredMethods = paymentMethods.filter((item) => item.amount != "");

  if (filteredMethods.length === 0 || filteredMethods.length > 1) {
    return false;
  }

  if (filteredMethods[0].value === "CASH" && roundedValues.decimal !== 0) {
    return true;
  }

  return false;
};

export const getRoundValues = (value) => {
  const val = getParsedNumber(value);
  let decimal = (val * 100) % 100;

  decimal = Math.round(decimal);
  const roundedPayable = decimal >= 50 ? Math.ceil(value) : Math.floor(value);

  const decimalValue = roundedPayable - val;

  return {
    roundedPayable,
    decimal,
    decimalValue,
    sign: decimal >= 50 || decimal === 0 ? "" : "-",
  };
};
/**
 * It will decide disable status of the pay later button
 * First priority will go to the selected payment method while placing order
 * Second priority on admin settings
 * Case 1: Paid order, it will be disabled
 * Case 1: If order created as counter payment then it will be unselected and disabled
 * Case 2: If order created as pay later it be default selected and in enabled mode means can be unselected
 *
 * @param {*} order
 */
export const shouldPayLaterDisplay = (order, isPayLater) => {
  if (order.orderId && order.payAfterEat) {
    return true;
  }

  return isPayLater;
};

export const shouldCheckedPayLater = (order, isPayLater) => {
  if (order.orderId) {
    return order.payAfterEat;
  }

  return isPayLater;
};

export const shouldDisablePayLater = (order) => {};

export const showHidePaymentForm = (orderRecord, payLater) => {
  if (!orderRecord) {
    return false;
  }

  if (orderRecord.status !== "pending" && orderRecord.paid === 0 && orderRecord.payAfterEat) {
    return true;
  }

  return orderRecord.paid === 0 && !payLater;
};

export const getPaymentMethods = (adminsPaymentOptions) => {
  const options = adminsPaymentOptions || [];

  return options.map((option) => ({
    label: option,
    value: option,
    ref: "",
    posBankId: "",
    amount: "",
  }));
};

export const orderAcceptWithoutPaymentSubmit = async (token, order, payLater, cookingTime) => {
  const result = {
    success: false,
    message: "Failed to accept order. Please, try again",
  };
  try {
    const reqBody = {
      orderId: order._id,
      selection: 1,
      payAfterEat: payLater ? "YES" : "NO",
      cookingTime,
    };

    const res = await ApiService.ORDER_STATUS_CHANGE(reqBody, token);

    if (res.code === 200) {
      result.success = true;
      result.message = "";

      return result;
    }

    result.message = res.data.message;

    return result;
  } catch (error) {
    console.error("Failed to accept order. Error:", error);
    return result;
  }
};

export const prepareOrderPaymentReqBody = (
  order,
  cookingTime,
  totalPayable,
  paymentMethods,
  discount,
  discountType,
  isSplitted,
  defaultRef,
  posBankId,
  couponCode
) => {
  const {
    paymentReceiveTypes,
    totalPaidAmount,
    totalReturnAmount,
    amount,
    actualDiscount,
    isDiscountInPercent,
    loyaltyDiscount
  } = getPaymentCommonInfo(paymentMethods, isSplitted, defaultRef, posBankId, totalPayable, discountType, discount);


  return {
    orderId: order._id,
    paymentPurpose: "ORDER",
    cookingTime,
    tableNumber: "",
    amount,
    discount: couponCode ? '' : getParsedNumber(actualDiscount),
    isDiscountInPercent,
    loyaltyDiscount,
    couponCode,
    discountNote: "",
    totalPaidAmount: parseFloat(totalPaidAmount),
    totalReturnAmount,
    paymentReceiveTypes,
  };
};

const orderPaymentSubmit = async (reqBody, token) => {
  const result = {
    success: true,
    message: "Failed to make payment. Please try again",
  };

  try {
    const res = await ApiService.ORDER_PAYMENT(reqBody, token);

    if (res.code === 200) {
      result.message = "";
      return result;
    }

    result.success = false;
    result.message = res.message;

    return result;
  } catch (error) {
    result.success = false;
    return result;
  }
};

export const validateLoyaltyDiscount = (discountType, discount, membershipInfo) => {
  if (discountType !== "Point Based") {
    return "";
  }

  if (getParsedNumber(discount) === 0) {
    return "";
  }

  if (getParsedNumber(discount) < membershipInfo.loyaltyDiscountInfo.minRedeemPoint) {
    return "Redeem points should be greater than the minimum redeem points";
  }
};

export const validateOrderAcceptPaymentForm = (
  order,
  payLater,
  cookingTime,
  totalPayable,
  paymentMethod,
  paymentMethods,
  discount,
  discountType,
  isSplitted,
  defaultRef,
  posBankId
) => {
  let result = { success: false, message: "Some required fields empty" };

  if (order.status.toLowerCase() === "pending" && getParsedNumber(cookingTime) < 1) {
    result.message = "Food preparing time is required";
    return result;
  }

  if ((order.status.toLowerCase() === "pending" && payLater) || order.paid === 1) {
    result.success = true;
    result.message = "";
    return result;
  }

  let reqBody = prepareOrderPaymentReqBody(
    order,
    cookingTime,
    totalPayable,
    paymentMethods,
    discount,
    discountType,
    isSplitted,
    defaultRef,
    posBankId
  );

  if (totalPayable < 0) {
    result.message = "Invalid discount.";
    return result;
  }

  if (reqBody.paymentReceiveTypes.length === 0 && totalPayable !== 0) {
    result.message = "No payment method provided with value.";
    return result;
  }

  
  if (reqBody.totalReturnAmount < 0) {
    result.message = "Payment amount cannot be less than total payable amount";
    return result;
  }

  const posInfo = reqBody.paymentReceiveTypes.find(item => item.paymentReceiveType === 'CARD')

  if (posInfo !== undefined && posInfo.posBankId.length === 0) {
    result.message = "Please select bank for POS payment.";
    return result;
  }

  result.message = "";
  result.success = true;

  return result;
};

export const orderAcceptAndPaymentRequest = async (
  user,
  order,
  payLater,
  cookingTime,
  totalPayable,
  paymentMethod,
  paymentMethods,
  discount,
  discountType,
  isSplitted,
  defaultRef,
  posBankId,
  couponCode
) => {
  try {

    console.log('orderAcceptAndPaymentRequest====', {couponCode});

    const token = user.token.token;
    let result = { success: true, message: "" };

    if (order.status.toLowerCase() === "pending" && (payLater || order.paid === 1)) {
      result = await orderAcceptWithoutPaymentSubmit(token, order, payLater, cookingTime);

      return result;
    }

    let reqBody = prepareOrderPaymentReqBody(
      order,
      cookingTime,
      totalPayable,
      paymentMethods,
      discount,
      discountType,
      isSplitted,
      defaultRef,
      posBankId,
      couponCode
    );

    result = orderPaymentSubmit(reqBody, token);

    return result;
  } catch (error) {
    console.error("----error---", error);
  }
};

export const orderPaymentRefund = async (token, orderId, paymentMethod, amount, refNo) => {
  const result = {
    success: true,
    message: "Failed to make payment. Please try again",
  };

  try {
    const reqBody = {
      actionType: "REFUND",
      orderId,
      amount,
      totalPaidAmount: amount,
      totalReturnAmount: 0,
      transactionTypes: [
        {
          transactionType: paymentMethod === "POS" ? "CARD" : paymentMethod,
          amount,
          refNo,
        },
      ],
    };
    const res = await ApiService.ORDER_PAYMENT_REFUND(reqBody, token);

    if (res.code === 200) {
      result.message = "";
      return result;
    }

    result.success = false;
    result.message = res.message;

    return result;
  } catch (error) {
    result.success = false;
    return result;
  }
};

export const orderDiscountSubmit = async (token, orderId, discount, discountType, couponCode) => {
  const result = {
    success: true,
    message: "Failed to give discount. Please try again",
  };

  try {
    let loyaltyDiscount = {
      discountType: discountType === "Point Based" ? "REDEEM" : "INSTANT_DISCOUNT",
      pointOrPercent: discount,
    };
    let actualDiscount = discount;
    let isDiscountInPercent = discountType.toLowerCase() === "amount" ? "NO" : "YES";

    if (["Point Based", "Spend Based"].includes(discountType)) {
      actualDiscount = 0;
    } else {
      loyaltyDiscount = undefined;
    }

    const reqBody = {
      orderId,
      discount: couponCode ? '' : actualDiscount,
      isDiscountInPercent,
      loyaltyDiscount,
      couponCode
    };

    console.log('=======orderDiscountSubmit========', {couponCode, discountType, discount, actualDiscount, loyaltyDiscount, reqBody});

    const res = await ApiService.ORDER_DISCOUNT(reqBody, token);

    if (res.code === 200) {
      result.message = getParsedNumber(discount) > 0 ?  "Discount applied successfully." : '';
      return result;
    }

    result.success = false;
    result.message = res.message;

    return result;
  } catch (error) {
    result.success = false;
    return result;
  }
};

export const sendPrintRequestUsingQZTray = async (printData, printerSettings) => {
  try {
    // Choose a printer — here we use the first one
    let selectedPrinter = "";
    if (printerSettings.connectionType === "USB") {
      selectedPrinter = printerSettings.usbDeviceName;
    }

    const config = qz.configs.create(selectedPrinter);

    const data = [
      {
        type: "raw",
        format: "base64",
        data: printData, // your base64 string from backend
      },
    ];

    await qz.print(config, data);
  } catch (err) {
    console.error("From Catch block: Print failed:", err);
  }
};

export const sendAutoPrintRequestUsingQZTray = async (orderRecord, isManual = false) => {
  const printerSettingsInvoice = orderRecord.restaurantInfo.printerSettingsInvoice || {};
  const printerSettingsKitchenSlip = orderRecord.restaurantInfo.printerSettingsKitchenSlip || {};

  const isAutoPrintInvoice = printerSettingsInvoice?.isAutoPrint || false;
  const isAutoPrintKitchenSlip = printerSettingsKitchenSlip?.isAutoPrint || false;

  // Print Invoice on receive payment by print
  if (orderRecord.status !== "pending" && isManual) {
    await sendPrintRequestUsingQZTray(orderRecord.base64DataPrint.invoice, printerSettingsInvoice);
  }

  if (orderRecord.status === "pending" && isAutoPrintInvoice) {
    await sendPrintRequestUsingQZTray(orderRecord.base64DataPrint.invoice, printerSettingsInvoice);
  }

  if (orderRecord.status === "pending" && isAutoPrintKitchenSlip) {
    await sendPrintRequestUsingQZTray(orderRecord.base64DataPrint.kitchenSlip, printerSettingsKitchenSlip);
  }
};

/**
 * 
User Online payment --------------> Both Invoice and Kitchen Slip
User Counter payment -------------> Both Invoice and Kitchen Slip
user Pay after eat   -------------> Only kitchen Slip
     admin receive payment -------> Only Invoice

Admin Pay first (Counter payment) -> Both Invoice and Kitchen Slip
Admin Pay after eat ---------------> Only Kitchen Slip
       receive payment ------------> Only Invoice

And
Invoice modal from where isMaual will be true
 * @param {*} orderRecord 
 * @param {*} token 
 * @param {*} showNotification 
 * @param {*} printPurpose 1 = Kitchen Slip, 2 = Invoice and Kitchen slip and 3 = Invoice
 * @param {*} isManual 
 */
export const processAndSendPrintCommand = async (
  orderRecord,
  token,
  showNotification,
  printPurpose,
  isManual = false
) => {
  const orderId = orderRecord.orderId || orderRecord._id || orderRecord.id;

  let purpose = "";

  if (printPurpose === 1) {
    purpose = "KITCHEN_SLIP";
  } else if (printPurpose === 2) {
    purpose = "INVOICE,KITCHEN_SLIP";
  } else if (printPurpose === 3) {
    purpose = "INVOICE";
  }

  const result = await sendPrintCommand(orderId, token, purpose, isManual);

  if (!result.success) {
    showNotification(result.message);
  }
};

/**
 * For auto Print only orderId and token is required
 *
 * @param {*} orderId
 * @param {*} token
 * @param {*} isManual
 * @param {*} isInvoice
 * @returns
 */
export const sendPrintCommand = async (orderId, token, printPurpose, isManual = false) => {
  const result = {
    success: true,
    message: "Failed to send print request. Kindly check printer and printer settings.",
  };

  try {
    // get device id from state as localstorage
    let deviceId = "";
    const generalStorage = localStorage.getItem("general-storage");

    if (generalStorage) {
      const tmp = JSON.parse(generalStorage);
      deviceId = tmp.state.deviceId;
    }

    const params = {
      printPurpose,
      deviceId,
      orderId,
    };

    const res = await ApiService.SEND_PRINT_REQUEST(params, token, isManual);

    if (res.code === 200) {
      result.message = "";
      return result;
    }

    result.success = false;
    result.message = res.message;

    return result;
  } catch (error) {
    result.success = false;
    return result;
  }
};

export const formatOrderFilter = (filter, paramType, param) => {
  if (!paramType) {
    return filter;
  }

  if (paramType === "SEARCH") {
    return {
      ...filter,
      page: 1,
      searchText: param,
    };
  }

  if (paramType === "SORTING") {
    return {
      ...filter,
      page: 1,
      sortBy: param,
    };
  }

  if (paramType === "ORDER_STATUS") {
    return {
      ...filter,
      page: 1,
      orderStatus: param,
    };
  }

  if (paramType !== "PAYMENT_STATUS") {
    return filter;
  }

  if (param.key === -1) {
    return {
      ...filter,
      page: 1,
      isPayLater: "",
      hasRefund: "",
      hasRefunded: "",
      hasDiscount: "",
      paymentStatus: "",
    };
  }

  if (param.key === 1 || param.key === 2) {
    return {
      ...filter,
      page: 1,
      isPayLater: "",
      hasRefund: "",
      hasRefunded: "",
      hasDiscount: "",
      paymentStatus: param.value,
    };
  }

  if (param.key === 3) {
    return {
      ...filter,
      page: 1,
      isPayLater: "YES",
      hasRefund: "",
      hasRefund: "",
      hasDiscount: "",
      paymentStatus: 0,
    };
  }

  if (param.key === 5) {
    return {
      ...filter,
      page: 1,
      isPayLater: "",
      hasRefund: "YES",
      hasRefunded: "",
      hasDiscount: "",
      paymentStatus: "",
    };
  }

  if (param.key === 7) {
    return {
      ...filter,
      page: 1,
      isPayLater: "",
      hasRefund: "",
      hasRefunded: "YES",
      hasDiscount: "",
      paymentStatus: "",
    };
  }

  if (param.key === 6) {
    return {
      ...filter,
      page: 1,
      isPayLater: "",
      hasRefund: "",
      hasRefunded: "",
      hasDiscount: "YES",
      paymentStatus: "",
    };
  }
};

export const getPaymentStatusValue = (orderFilters) => {
  if (!Boolean(orderFilters)) {
    return undefined;
  }

  if (orderFilters.hasDiscount) {
    return constants.PAYMENT_STATUS.DISCOUNT;
  }

  if (orderFilters.hasRefund) {
    return constants.PAYMENT_STATUS.REFUND;
  }

  if (orderFilters.hasRefunded) {
    return constants.PAYMENT_STATUS.REFUNDED;
  }

  if (orderFilters.isPayLater) {
    return constants.PAYMENT_STATUS.PAY_LATER;
  }

  if (orderFilters.paymentStatus) {
    return constants.PAYMENT_STATUS.PAID;
  }

  if (orderFilters.paymentStatus === 0) {
    return constants.PAYMENT_STATUS.UNPAID;
  }

  return undefined;
};
